import { Button, ButtonProps, IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useLanguage } from "../../Language";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { useIsMobile } from "../../../hooks/useIsMobile";
import { useAddToListDialog } from "../search/ls/AddToListDialog";

interface AddToListButtonProps extends ButtonProps {
  defaultName?: string;
  resourceId: number;
  dense?: boolean;
}

export const AddToListButton = ({
  defaultName,
  resourceId,
  dense,
  ...props
}: AddToListButtonProps) => {
  const { translate } = useLanguage();
  const isMobile = useIsMobile();
  const { showDialog } = useAddToListDialog();
  const onClick = () => showDialog([resourceId], defaultName);
  return (
    <>
      {dense || isMobile ? (
        <Tooltip title={translate("addToList")}>
          <IconButton
            {...props}
            onClick={onClick}
            color={"primary"}
            aria-label={translate("addToList")}
          >
            <PlaylistAddIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          {...props}
          onClick={onClick}
          variant="outlined"
          sx={{ whiteSpace: "nowrap" }}
          startIcon={<PlaylistAddIcon />}
        >
          {translate("addToList")}
        </Button>
      )}
    </>
  );
};
